import { apiFetch } from "../api.js";
import type { AlertsListResponse } from "./types.js";

/**
 * Alerts API module — Phase 15.5 (2026-05-10). Currently exposes
 * `GET /v1/alerts` for the History tab on `/alerts` and the
 * fire-marker layer on `/chart/{ticker}`.
 *
 * Future endpoints (acknowledge, dismiss) live in this module.
 */

export interface ListAlertsArgs {
  /**
   * Comma-separated alert_type filter. Defaults to `"signal_fired"`
   * server-side — pass other types only when surfacing them.
   */
  type?: string;
  /** Lookback window in days, 1–365. Defaults to 90. */
  days?: number;
  /** Filter by `fired_ticker` (server-side, case-insensitive). */
  ticker?: string;
  /** Pagination cursor returned by a prior call. */
  cursor?: string;
}

export function listAlerts(args: ListAlertsArgs = {}): Promise<AlertsListResponse> {
  const params = new URLSearchParams();
  if (args.type) params.set("type", args.type);
  if (typeof args.days === "number") params.set("days", String(args.days));
  if (args.ticker) params.set("ticker", args.ticker);
  if (args.cursor) params.set("cursor", args.cursor);
  const qs = params.toString();
  return apiFetch<AlertsListResponse>(`/v1/alerts${qs ? `?${qs}` : ""}`);
}
